/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blue_Tough_Fly_EmergeInputs */

const fr_blue_tough_fly_emerge = /** @type {(inputs: Blue_Tough_Fly_EmergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liste des Packs`)
};

/**

* @param {Blue_Tough_Fly_EmergeInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const blue_tough_fly_emerge = /** @type {((inputs?: Blue_Tough_Fly_EmergeInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blue_Tough_Fly_EmergeInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_blue_tough_fly_emerge(inputs)
});